import React from "react";
import { BrowserRouter, Switch, Route, Redirect } from "react-router-dom";

import Login from "@/pages/Login";
import GuiComponent from "../playground/GuiComponent.jsx";
import VersionFooter from "@/components/version-footer/index.jsx";
import RegisterPage from "@/pages/Register/index.jsx";
import cookie from "cookie";
import { COURSE_URL, API_ENV } from "@/utils/envConfig";

// 私有路由组件，用于检查用户是否已登录
const PrivateRoute = ({ children, ...rest }) => {
    // const isAuthenticated = localStorage.getItem("token");
    const cookies = cookie.parse(document.cookie);
    const xiaozhi_token = cookies["xiaozhi_token"];
    const course_token = cookies["course_token"];
    
    // 如果 xiaozhi_token 存在但 course_token 不存在，清除 xiaozhi_token 并跳转
    if (xiaozhi_token && !course_token) {
        console.log("[DEBUG] course_token not found, clearing xiaozhi_token and redirecting");
        document.cookie = "xiaozhi_token=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/";
        
        // 根据环境判断跳转地址
        console.log("[DEBUG] Redirecting to:", COURSE_URL);
        window.location.href = COURSE_URL;
        return null;
    }
    
    const isAuthenticated = xiaozhi_token && course_token;
    
    // 如果没有登录，跳转到课程平台（根据环境判断地址）
    if (!isAuthenticated) {
        console.log("[DEBUG] Not authenticated, redirecting to course platform:", COURSE_URL);
        window.location.href = COURSE_URL;
        return null;
    }
    
    return (
        <Route
            {...rest}
            render={({ location }) =>
                isAuthenticated ? (
                    children
                ) : null
            }
        />
    );
};

// 主路由配置
const AppRouter = () => (
    <>
        <BrowserRouter>
            <Switch>
                <Route path="/login">
                    <Login />
                </Route>
                <Route path="/register">
                    <RegisterPage />
                </Route>
                <PrivateRoute path="/agentManage">
                    <GuiComponent pathName="agentManage" />
                </PrivateRoute>
                <PrivateRoute path="/">
                    <GuiComponent />
                </PrivateRoute>
            </Switch>
        </BrowserRouter>
        <VersionFooter />
    </>
);

export default AppRouter;
